import styled, { css } from 'styled-components';
import { skeletonAnimation } from '../../styles/animation';

export const CardWrapper = styled.article`
  min-width: 250px;
  min-height: 150px;
  margin-right: 10px;
  &:first-child {
    margin-right: 0;
  }
`;
export const Card = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  height: auto;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  -webkit-transform-origin: center left;
  transform-origin: center left;

  ${(props) =>
    props.isLoading === 'true' &&
    css`
      ${skeletonAnimation({
        colorBackground: '#2d2f33',
        colorAnimation: '#333',
      })}
    `}
`;

export const Img = styled.img`
  font-size: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  ${(props) =>
    props.isLoading &&
    css`
      display: none;
    `}
`;

export const ImgWrapper = styled.div`
  width: 100%;
  min-width: 100px;
  height: 150px;
  overflow: hidden;
`;

export const Title = styled.div`
  margin-top: 10px;
  color: white;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: pre-wrap; /* css-3 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
  word-break: break-all;
  white-space: normal;
  -webkit-transition: all 5s -webkit-transform;
  transition: all 5s -webkit-transform;
  transition: all 5s;
  transition: all 5s -webkit-transform;
  ${(props) =>
    props.isLoading &&
    css`
      display: none;
      transform: translateY(-23px);
    `}
`;
